<script>
    import { onMount, onDestroy, afterUpdate, getContext } from 'svelte'
    import PerfectScrollbar from 'perfect-scrollbar';
    
    export let height       = 0
    export let width        = '100%'
    export let ref          = null
    export let container    = null
    export let options      = {
        wheelPropagation: false,
        minScrollbarLength: 30
    }
    
    const isMobile = getContext ('mobileDevice')
    
    afterUpdate (() => {
        if (ref)
            ref.update ();
    });

    onMount (() => {
        if (isMobile === false)
            ref = new PerfectScrollbar (container, options);
    });

    onDestroy (() => {
        if (ref) {
            ref.destroy ();
            ref = null;
        }
    })
</script>

<style>
    .ScrollContainer {
        position: relative;
        overflow: hidden;
    }
    .ScrollContainer.mobile {
        overflow: auto;
    }
</style>

<div bind:this={container} 
    class="ScrollContainer" 
    class:mobile={isMobile} 
    style="height:{height}px;width:{width}">
    <slot></slot>
</div>